export default __webpack_public_path__ + "static/media/CheckboxActive.d2034248.svg";